var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSaveIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_24061",
    "data-name": "Group 24061",
    transform: "translate(-1164 -542)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2176",
    "data-name": "Ellipse 2176",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(1164 542)",
    fill: "#f7f3ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_342039",
    "data-name": "Path 342039",
    d: "M33,14.925H17A2.076,2.076,0,0,0,14.925,17V33A2.076,2.076,0,0,0,17,35.075H33A2.076,2.076,0,0,0,35.075,33V17A2.076,2.076,0,0,0,33,14.925Zm-4.075,19h-7.85v-5.85h7.85Zm5-.925a.926.926,0,0,1-.925.925H30.075V27.5a.576.576,0,0,0-.575-.575h-9a.576.576,0,0,0-.575.575v6.425H17A.926.926,0,0,1,16.075,33V17A.926.926,0,0,1,17,16.075h2.925V19.5a.576.576,0,0,0,.575.575h8a.575.575,0,0,0,0-1.15H21.075v-2.85H33a.926.926,0,0,1,.925.925Z",
    transform: "translate(1159.075 537.074)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveIcon);
export default __webpack_public_path__ + "static/media/save_icon.1cab6307652476474edb0836f387aba3.svg";
export { ForwardRef as ReactComponent };